import React, { useImperativeHandle, useState, useRef } from 'react';
import FutureDialog from '@Local/CyclePurchase/Detail/Future/Dialog/FutureDialog';      
import useForkRef from '@Util/hook/useForkRef';

const FutureDialogBox = React.forwardRef((props, ref) => {
    const { cycleOrderID, clubName } = props;
    const dialogRef = useRef(null);
    const combinedRef = useForkRef(ref, dialogRef);
    const [openDialog, setOpenDialog] = useState('');
    const [sourceData, setSourceData] = useState(null);
    const refreshRef = useRef(null);

    const doRefresh = () => {
        if (refreshRef.current && typeof refreshRef.current === 'function') refreshRef.current();
    };

    useImperativeHandle(
        combinedRef,
        () => {
            return {
                openCustomerResourceDialog: (targetData, _refreshFn = () => {}) => {
                    setSourceData({ 
                        effectID: targetData.id,
                        cycleOrderID: cycleOrderID,
                        clubName: clubName
                    });
                    setOpenDialog('future');
                    refreshRef.current = _refreshFn;
                },
                closeDialog: () => handleCloseDialog(),
            };
        },
        // eslint-disable-next-line
        [],
    );

    const handleCloseDialog = () => {
        setOpenDialog(null);
        setSourceData(null);
        refreshRef.current = null;
    };

    return (
        <React.Fragment>
            <FutureDialog open={openDialog === 'future'} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
        </React.Fragment>
    );
});

export default FutureDialogBox;    
